import { Grid, Box } from "@mui/material"
import Link from "components/Link"
import Page from "components/Page"

const Links = () => {
  return (
    <Page id="links">
      <Grid container direction="column" alignItems="center" justifyContent="center" padding={2}>
        <Box margin={2}></Box>
        <Link label={"art.blocks"} url={"https://www.artblocks.io/profile/pxlq"}/>
        <Link label={"automaton.pxlq.art"} url={"https://automaton.pxlq.art"}/>
        <Link label={"automaton.raster"} url={"https://www.raster.art/artwork/1665712"}/>
        <Link label={"catalog.ships.pxlq.art"} url={"https://catalog.ships.pxlq.art"}/>
        <Link label={"cyber.cities"} url={"https://www.artblocks.io/project/14"}/>
        <Link label={"cyber.pxlq.art"} url={"https://cyber.pxlq.art"}/>
        <Link label={"cyber.raster"} url={"https://www.raster.art/artwork/15056"}/>
        <Link label={"cyber.reimagined"} url={"https://lattice.cyber.pxlq.art"}/>
        <Link label={"cyber.space"} url={"https://oncyber.io/art-blocks?id=14000014"}/>
        <Link label={"deca.art"} url={"https://deca.art/pxlqart"}/>
        <Link label={"envelop.pxlq.art"} url={"https://envelop.pxlq.art"}/>
        <Link label={"ethblock.art"} url={"https://ethblock.art/profile/pxlq.eth"}/>
        <Link label={"ethos"} url={"https://app.ethos.network/profile/x/pxlqart"}/>
        <Link label={"foundation.app"} url={"https://foundation.app/@pxlq"}/>
        <Link label={"farcaster"} url={"https://farcaster.xyz/pxlq"}/>
        <Link label={"infinethum.ephemeral"} url={"https://generator.pxlq.art/infinethum"}/>
        <Link label={"infinethum.raster"} url={"https://www.raster.art/artwork/1981481"}/>
        <Link label={"infinethum.xyz"} url={"https://infinethum.xyz"}/>
        <Link label={"infinethum.hydra"} url={"https://hydra.ojack.xyz/?code=czAuaW5pdEltYWdlKCdodHRwcyUzQSUyRiUyRmFwaS5pbmZpbmV0aHVtLnh5eiUyRmltYWdlJTJGNCcpJTBBc3JjKHMwKSUwQS5tb2R1bGF0ZShvc2MoMTApKSUwQS5tb2R1bGF0ZVJvdGF0ZShub2lzZSgoKSUyMCUzRCUzRSUyMCgobW91c2UueSUyMCUyRiUyMGhlaWdodCkpJTIwKiUyMDEwJTJDJTIwMCklMkMlMjA1KSUwQS5tb2R1bGF0ZVJvdGF0ZShub2lzZSgoKSUyMCUzRCUzRSUyMCgobW91c2UueCUyMCUyRiUyMHdpZHRoKSklMjAlMjAqJTIwMTAlMkMlMjAwKSUyQyUyMDUpJTBBLm91dCgpJTBB"}/>
        <Link label={"known.origin"} url={"https://knownorigin.io/pxlq"}/>
        <Link label={"motif.pxlq.art"} url={"https://motif.pxlq.art"}/>
        <Link label={"observatory.ships"} url={"https://observatory.ships.pxlq.art"}/>
        <Link label={"on.cyber"} url={"https://oncyber.io/@0xb56ae8a727cf38f1f4716aeda6749d2af340d8f4"}/>
        <Link label={"open.sea"} url={"https://opensea.io/pxlq"}/>
        <Link label={"pxlq.eth"} url={"https://app.ens.domains/name/pxlq.eth"}/>
        <Link label={"raster.art"} url={"https://www.raster.art/artist/pxlq"}/>
        <Link label={"rodeo.club"} url={"https://rodeo.club/@pxlqart/collection"}/>
        <Link label={"rorschach.pxlq.art"} url={"https://rorschach.pxlq.art"}/>
        <Link label={"ships.raster"} url={"https://www.raster.art/artwork/348704"}/>
        <Link label={"sothebys"} url={"https://www.sothebys.com/en/search?query=pxlq&pfilters.dateRange=past"}/>
        <Link label={"zora.co"} url={"https://zora.co/@pxlqart/holdings"}/>
        <Box margin={2}></Box>
      </Grid>
    </Page>
  )
}

export default Links
